import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const paises = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('endereco/pesquisa/paises',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data,types.ENDERECO.PESQUISA_PAIS);

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const tipologradouro = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('endereco/pesquisa/tipologradouros',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data,types.ENDERECO.PESQUISA_TIPOLOGRAOURO);

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const pesquisacep = (cep) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('endereco/pesquisa/cep',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        cep: cep
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data,types.ENDERECO.PESQUISA_CEP);
            return response.data;

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const estados = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('endereco/pesquisa/estados',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data,types.ENDERECO.PESQUISA_ESTADOS);

            return response.data;
            
        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const cidade = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('endereco/pesquisa/cidades',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data,types.ENDERECO.PESQUISA_CIDADES);

            return response.data;

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}